/* eslint-disable import/no-unresolved */
import { useMutation, useQuery } from "react-query";
import { useDispatch } from "react-redux";
import FormDetails from "src/components/FormDetails";
import {
  SET_JOINT_ADDENDUM_STATE,
  setLeadId,
  setLeadDetails,
  setLoanStatus,
  setProposalStatus,
  setIsProportionateLead,
  setIsProportionateParentLead,
  setProductId,
  setStaffMember,
  savePartnerData,
  setAssignmentFlagStatus
} from "src/redux/Actions/common";
// import CustomBackDrop from "src/shared/CustomBackDrop";
import {
  genderDetails,
  educationDetails,
  relationshipDetails,
  occupationDetails,
  salutationDetails,
  maritalStatusDetails,
  insuranceCompanyDetails,
  policyStatusDetails,
  callRuleEngine,
  product,
  channel,
  getMefJourneySchema
} from "src/services/Master";
import CustomLoader from "src/shared/CustomLoader";
import { MasterAction, setQuestionnaire } from "src/redux/Actions/Masters";
import {
  SET_ASSIGNMENT_OCCUPATION_DETAILS,
  SET_CHANNEL,
  SET_EDUCATION_DETAILS,
  SET_GENDER_DETAILS,
  SET_INSURANCE_COMPANY,
  SET_JOINT_RELATIONSHIP_DETAILS,
  SET_MARITAL_STATUS_DETAILS,
  SET_MEF_JOURNEY_SCHEMA,
  SET_OCCUPATION_DETAILS,
  SET_POLICY_STATUS,
  SET_PRODUCT,
  SET_RELATIONSHIP_DETAILS,
  SET_RULE_ENGINE,
  SET_SALUTATION_DETAILS
} from "src/redux/Types/Masters";
import { useParams } from "react-router";
import {
  saveJointMemberDetails,
  saveProposerDetails,
  saveLoanDetails,
  saveGeneralDetails,
  saveCovidAndNriDetails,
  savemedicalDetails,
  saveMedicalDetailsV2
} from "src/redux/Thunk";
import store from "src/redux/store";
import { useState, useEffect } from "react";
import { getLeadInfo } from "src/services/LeadInfo";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { Button } from "@mui/material";
import Header from "src/shared/Header";
import { CoverType } from "src/config/constant";
import { enterMEFJourney } from "src/helpers/Dashboard/resources";
import { getQuestionnaireVersion } from "src/helpers/FormDetails";

function FormDetailsPage() {
  const dispatch = useDispatch();
  const { leadId } = useParams();
  const [isMasterLoaded, setIsMasterLoaded] = useState(false);
  const isMasterFetching = useAppSelector((state) => state.common.isMasterFetching);
  const navigate = useNavigate();
  const {
    mutate: mutateRuleEngine,
    isLoading: isRuleEngineLoading,
    isError: isRuleEngineError
  } = useMutation(
    ({
      productId,
      partnerId,
      loanType,
      questionnaireVersion
    }: {
      productId: string;
      partnerId: string;
      loanType: string;
      questionnaireVersion: boolean;
    }) => callRuleEngine(productId, partnerId, loanType, questionnaireVersion),
    {
      retry: false,
      onSuccess: (response) => {
        store.dispatch(setStaffMember(response.staffMember));
        dispatch(
          MasterAction(SET_RULE_ENGINE, {
            productMaster: response?.productMaster,
            productId: response?.productId,
            partnerId: response?.partnerId
          })
        );
        dispatch(setQuestionnaire(response?.QuestionnairesAssociations));
      }
    }
  );

  const {
    mutate: fetchMefJourneySchema,
    isLoading: isMefSchemaLoading,
    isError: isMefSchemaError
  } = useMutation(
    ({
      productId,
      partnerId,
      loanType
    }: {
      productId: string;
      partnerId: string;
      loanType: string;
    }) => getMefJourneySchema(productId, partnerId, loanType),
    {
      retry: false,
      onSuccess: (response) => {
        dispatch(MasterAction(SET_MEF_JOURNEY_SCHEMA, response));
      }
    }
  );

  const { isFetching: isLeadLoading, isError: isLeadError } = useQuery(
    ["getLeadInfo"],
    () =>
      getLeadInfo(
        localStorage.getItem("leadId") !== null ? localStorage.getItem("leadId") : leadId
      ),
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: (leadId !== null || localStorage.getItem("leadId") !== null) && isMasterLoaded,
      onSuccess: async (res) => {
        if (enterMEFJourney(res?.data)) {
          const questionnaireVersion = getQuestionnaireVersion(
            res.data?.Members,
            res?.data?.proposalStatus
          );
          mutateRuleEngine(
            {
              productId: res.data?.productId,
              partnerId: res.data?.partnerId,
              loanType: res?.data?.loanCategory,
              questionnaireVersion
            },
            {
              onSuccess: () => {
                fetchMefJourneySchema({
                  productId: res?.data?.productId,
                  partnerId: res?.data?.partnerId,
                  loanType: res?.data?.loanCategory
                });
                store.dispatch(setProductId(res?.data?.productId));
                store.dispatch(setLeadId(res.data?.id));
                const partnerDataPayload = {
                  showAssignmentFlag: res?.data?.PartnerConfig?.showAssignmentFlag,
                  partnerCode: res?.data?.PartnerConfig?.partnerCode,
                  partnerName: res?.data?.PartnerConfig?.partnerName,
                  masterPolicyHolderName: res?.data?.PartnerConfig?.masterPolicyHolderName,
                  showOtpVerification: res?.data?.PartnerConfig?.showOtpVerification ?? false
                };

                store.dispatch(savePartnerData(partnerDataPayload));
                store.dispatch(setAssignmentFlagStatus(res?.data?.assignmentFlag));
                store.dispatch(setProposalStatus({ status: res?.data?.proposalStatus }));
                store.dispatch(setLoanStatus({ loanStatus: res?.data?.loanStatus }));
                // store.dispatch(setLoanStatus({ loanStatus: "Sanctioned" }));
                store.dispatch(setLeadDetails(res.data));
                dispatch(SET_JOINT_ADDENDUM_STATE({ isJointState: res?.data?.jointLifeCoverage }));
                store.dispatch(setIsProportionateLead(!!res?.data?.parentProportionateId));
                store.dispatch(
                  setIsProportionateParentLead(!!(res?.data?.coverType === CoverType.PROPORTIONATE))
                );
                store.dispatch(saveGeneralDetails(res?.data, leadId || ""));
                store.dispatch(saveCovidAndNriDetails(res?.data, leadId || ""));
                store.dispatch(saveProposerDetails(res.data, leadId || ""));
                store.dispatch(saveJointMemberDetails(res.data, leadId || ""));
                store.dispatch(saveLoanDetails(res.data, leadId || ""));
                store.dispatch(savemedicalDetails(res.data, leadId || ""));
                store.dispatch(saveMedicalDetailsV2(res.data, leadId || ""));
              }
            }
          );
        } else {
          navigate(`/view-lead-details/${res.data?.id}`);
        }
      }
    }
  );

  const fetchAllData = async () => {
    const [
      genderData,
      educationData,
      relationData,
      jointRelationData,
      allOccupationData,
      assignmentOccupationData,
      salutationData,
      maritalStatusData,
      insuranceCompanyData,
      policyStatusData,
      productData,
      channelData
      // subOccupationData
    ] = await Promise.all([
      genderDetails(),
      educationDetails(),
      relationshipDetails("single"),
      relationshipDetails("joint"),
      occupationDetails("isActive"),
      occupationDetails("isAssignmentActive"),
      salutationDetails(),
      maritalStatusDetails(),
      insuranceCompanyDetails(),
      policyStatusDetails(),
      product(),
      channel()
      // subOccupationDetails(),
    ]);

    return {
      genderData,
      educationData,
      relationData,
      jointRelationData,
      allOccupationData,
      assignmentOccupationData,
      salutationData,
      maritalStatusData,
      insuranceCompanyData,
      policyStatusData,
      productData,
      channelData
      // subOccupationData,
    };
  };

  const {
    data: allData,
    isFetching: isDataLoading,
    isError: isDataError
  } = useQuery("allData", fetchAllData, {
    refetchOnWindowFocus: false,
    retry: false,
    enabled: true,
    onSuccess: () => {
      setIsMasterLoaded(true);
    }
  });

  useEffect(() => {
    // Check if all data is loaded and the Master Dispatch has not been called yet
    if (isMasterLoaded && allData) {
      dispatch(MasterAction(SET_GENDER_DETAILS, allData.genderData.data));
      dispatch(MasterAction(SET_RELATIONSHIP_DETAILS, allData.relationData));
      dispatch(MasterAction(SET_OCCUPATION_DETAILS, allData.allOccupationData));
      dispatch(MasterAction(SET_ASSIGNMENT_OCCUPATION_DETAILS, allData.assignmentOccupationData));
      dispatch(MasterAction(SET_SALUTATION_DETAILS, allData.salutationData));
      dispatch(MasterAction(SET_MARITAL_STATUS_DETAILS, allData.maritalStatusData));
      dispatch(MasterAction(SET_EDUCATION_DETAILS, allData.educationData));
      dispatch(MasterAction(SET_INSURANCE_COMPANY, allData.insuranceCompanyData));
      dispatch(MasterAction(SET_POLICY_STATUS, allData.policyStatusData));
      dispatch(MasterAction(SET_JOINT_RELATIONSHIP_DETAILS, allData.jointRelationData));
      dispatch(MasterAction(SET_PRODUCT, allData.productData));
      dispatch(MasterAction(SET_CHANNEL, allData.channelData));
    }
  }, [isMasterLoaded, allData, dispatch]);

  const handleRetry = () => {
    window.location.reload();
  };

  if (
    isDataLoading ||
    isLeadLoading ||
    isRuleEngineLoading ||
    isMasterFetching ||
    isMefSchemaLoading
  ) {
    return (
      <div>
        <CustomLoader />
      </div>
    );
  }

  if (isDataError || isLeadError || isRuleEngineError || isMefSchemaError) {
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <p className="font-bold text-lg mb-4">No Data Found</p>
        <Button
          variant="contained"
          classes={{ contained: "!rounded-lg" }}
          className="!uppercase m-auto"
          onClick={handleRetry}
        >
          RETRY
        </Button>
      </div>
    );
  }

  // if (isLeadError) {
  //   return <div className="text-center mt-20 text-2xl font-bold text-hotShot">No Data Found</div>;
  // }

  return (
    <div>
      {/* <CustomBackDrop open={isLeadLoading} /> */}
      <Header isEnable />
      <FormDetails />
    </div>
  );
}

export default FormDetailsPage;
